import axios from 'axios';
import * as types from 'reducer/actionTypes';
import { isEmpty } from './common';
import main from 'reducer/main';

let prefix = null;
let prefixUni = null;

if (isEmpty(prefix)) {
	const initialState = main(undefined, { type: '@@INIT' });
	prefix = initialState.basename

	if (isEmpty(prefix)) {
		const stateWithBasename = main(initialState, { type: types.SET_BASENAME });
		prefix = stateWithBasename.basename
	}

	prefix = prefix + "/rest"
	prefixUni = prefix + "/uniAdapter"
}

//checkIP
export function checkIP() {
	const request = axios.get(prefix + '/checkIP.do');
	return request
}

// login
export function authLogin(params) {
	return axios({
		method: 'post',
		url: prefix + '/login.do',
		params: {
			username: params.id,
			password: params.pw
		}
	})
}

// account
export function getLanguage() {
	return axios.get(prefix + '/get/language.do',)
}

export function setLanguage(params) {
	return axios({
		method: 'post',
		url: prefix + '/set/language.do',
		params: {
			language: params.value
		}
	})
}
export function changeUserId(params) {
	const formData = new FormData();
	formData.append('useridChangeValidatorVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/set/changeUserId.do',
		data: formData
	})
}

export function changePasswd(params) {
	const formData = new FormData();
	formData.append('passwordChangeValidatorVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/set/changePassword.do',
		data: formData
	})
}

export function getAccountInfo() {
	return axios.get(prefix + '/get/setting/account.do',)
}

// license
export function licenseInfo() {
	return axios.get(prefix + '/get/license.do')
}

export function licenseRegister(params) {
	const formData = new FormData();
	formData.append('licenseFile', params.licenseFile[0]);

	return axios({
		method: "post",
		headers: { "Content-Type": "multipart/form-data" },
		url: prefix + '/set/license/register.do',
		data: formData
	});
}

export function licenseExportData(params) {
	const { startDate, endDate } = params;
	return axios.get(`${prefix}/export/licenseStats.do`, {
		params: { startDate, endDate },
		responseType: 'blob'
	});
}

// adapter 
export function getAdapterList() {
	return axios({
		method: 'get',
		url: prefix + '/get/adapter.do',
	})
}

export function setAdapterRegister(params) {
	const formData = new FormData();
	formData.append('adapterAddValidatorVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));
	formData.append('adapterFile', params.adapterFile);

	return axios({
		method: 'post',
		url: prefix + '/set/adapter/register.do',
		data: formData
	})
}

export function setAdapterUnresiter(params) {
	return axios({
		method: 'post',
		url: prefix + '/set/adapter/unregister.do',
		params: { adapter: params.adapter }
	})
}

export function setAdapterUpdate(params) {
	const formData = new FormData();
	formData.append('adapterAddValidatorVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));
	formData.append('adapterFile', params.value.files[0]);

	return axios({
		method: 'post',
		url: prefix + '/set/adapter/update.do',
		data: formData
	})
}

export function setAdapterEnable(params) {
	return axios({
		method: 'post',
		url: prefix + '/set/adapter/enable.do',
		params: {
			adapter: params.adapter,
			state: params.state
		}
	})
}

export function getAdapterDetail(params) {
	return axios({
		method: 'post',
		url: prefix + '/get/adapter/detail.do',
		params: { adapter: params.adapter }
	})
}

export function setAdapterStorage(params) {
	const formData = new FormData();
	formData.append('adapter', params.adapter);
	formData.append('storageName', params.storageName);

	return axios({
		method: 'post',
		url: prefix + '/set/adapter/storagename.do',
		data: formData
	})
}

export function setAdapterParams(params) {
	const formData = new FormData();
	formData.append('adapter', params.adapter);
	formData.append('paramsName', params.paramsName);

	return axios({
		method: 'post',
		url: prefix + '/set/adapter/params.do',
		data: formData
	})
}

export function setAdapterRootPath(params) {
	const formData = new FormData();
	formData.append('adapter', params.adapter);
	formData.append('rootName', params.rootName);
	formData.append('rootPath', params.rootPath);

	return axios({
		method: 'post',
		url: prefix + '/set/adapter/rootpath.do',
		data: formData
	})
}

// stats
export function statsSummaryTotal(params) {
	const formData = new FormData();
	formData.append('statsVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/get/stats/summary/total.do',
		data: formData
	})
}

export function statsSummaryInfo(value) {
	const formData = new FormData();
	formData.append('statsVO', new Blob([JSON.stringify(value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/get/stats/summary/info.do',
		data: formData
	})
}

export function statsSummaryCsv(params) {
	const formData = new FormData();
	formData.append('statsVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/get/stats/summary/csv.do',
		data: formData
	})
}

// setting
export function getSettingGroupIdInfo() {
	return axios({
		method: 'get',
		url: prefix + '/get/setting/groupId.do'
	})
}

export function getSettingInfo() {
	return axios({
		method: 'get',
		url: prefix + '/get/setting.do',
	})
}

export function setSettingUpdate(params) {
	return axios({
		method: 'post',
		url: prefix + '/set/setting.do',
		data: params.value,
	})
}

// settings
export function getSettings() {
	return axios({
		method: 'get',
		url: prefix + '/get/settings.do',
	})
}

export function setSettings(params) {
	return axios({
		method: 'post',
		url: prefix + '/set/settings.do',
		data: params.value
	})
}

export function getSettingData(params) {
	return axios({
		method: 'get',
		url: prefix + '/get/setting/data.do',
		params: {
			key: params.key
		}
	})
}

export function getSettingDataByKeyList(params) {
	const formData = new FormData();
	formData.append('keyList', new Blob([JSON.stringify(params.keyList)], { type: "application/json" }));
	formData.append('appList', new Blob([JSON.stringify(params.appList)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/get/setting/data.do',
		data: formData
	})
}

export function getSettingAdditional(params) {
	return axios({
		method: 'get',
		url: prefix + '/get/setting/additional/list.do',
	})
}

export function getSettingAdditionalDefaultKey(params) {
	return axios({
		method: 'get',
		url: prefix + '/get/setting/additional/defaultKey.do',
		params: {
			key: params.key
		}
	})
}

export function setSettingData(params) {
	const formData = new FormData();
	formData.append('isSingle', new Blob([JSON.stringify(params.isSingle)], { type: "application/json" }));
	formData.append('settingVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/set/setting/service.do',
		data: formData
	})
}

export function setSettingRedisMode(params) {
	const formData = new FormData();
	formData.append('isSingle', params.isSingle);
	formData.append('mode', params.mode);
	formData.append('nodes', params.nodes);

	return axios({
		method: 'post',
		url: prefix + '/set/setting/redis/mode.do',
		data: formData
	})
}

export function setSettingAdditionalData(params) {
	const formData = new FormData();
	formData.append('settingVO', new Blob([JSON.stringify(params.value)], { type: "application/json" }));

	return axios({
		method: 'post',
		url: prefix + '/set/setting/additional/data.do',
		data: formData
	})

}

export function setUICustomization(params) {
	const formData = new FormData();

	const settings = [];

	if (Array.isArray(params.value)) {
		params.value.forEach(param => {
			if (param.value instanceof File) {
				formData.append(param.key, param.value, param.value.name);
			} else {
				settings.push({
					key: param.key,
					value: param.value,
				});
			}
		});
	} else {
		console.error('params.value is not an array');
		return;
	}

	formData.append('settingVO', new Blob([JSON.stringify(settings)], { type: 'application/json' }));

	return axios({
		method: 'post',
		url: prefix + '/set/setting/ui/customization.do',
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
}

export function getUICustomization() {
	return axios({
		method: 'get',
		url: prefix + '/get/setting/ui/customization/list.do'
	})
}

// WebFont
export function uploadWebFont(params) {
	const formData = new FormData();
	formData.append('fontFile', params.fontFile);
	if (params.localeInfo) {
		formData.append('localeInfo', JSON.stringify(params.localeInfo));
	}

	return axios({
		method: 'post',
		url: prefix + '/webfont/upload.do',
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
}

export function getWebFontList() {
	return axios({
		method: 'get',
		url: prefix + '/webfont/list.do'
	})
}

export function deleteWebFont(params) {
	return axios({
		method: 'post',
		url: prefix + '/webfont/delete.do',
		params: {
			fontId: params.fontId
		}
	})
}

// monitoring
export function getMonitoringData() {
	return axios({
		method: 'get',
		url: prefix + '/get/monitoring/data.do',
	})
}


/**
 * ==========================================================================================================================
 * UNIADAPTER
 * prefixUni = rest/uniAdapter/*
 * ==========================================================================================================================
 */
export function getSampleWebofficeURL(adapterName) {
	return axios({
		method: 'get',
		url: prefixUni + '/get/sampleWebofficeURL.do',
		params: {adapterName},
	})
}

export function setSampleWebofficeURL(params) {
	return axios({
		method: 'post',
		url: prefixUni + '/set/sampleWebofficeURL.do',
		params: params.value
	})
}

export function setResetUniadapterInterface() {
	return axios({
		method: 'post',
		url: prefixUni + '/set/reset.do',
	})
}

export function executeUniAdapterRequest(params) {
	const formData = new FormData();
	formData.append('requestBody', new Blob([JSON.stringify(params.value)], { type: 'application/json' }));

	if (params.uploadFile) {
		formData.append('uploadFile', params.uploadFile);
	}

	return axios({
		method: 'post',
		url: prefixUni + '/execute/request.do',
		data: formData
	});
}

export function getUniAdapterParam(adapterName) {
	return axios({
		method: 'get',
		url: prefixUni + '/get/adapterParam.do',
		params: {adapterName},
	})
}

export function getUniAdapterInterface(params) {
	return axios({
		method: 'post',
		url: prefixUni + '/get/interface.do',
		data: params.value,
		headers: {
			'Content-Type': 'application/json' // JSON으로 보내기
		}
	})
}

export function setUniAdapterInterface(params) {
	return axios({
		method: 'post',
		url: prefixUni + '/set/interface.do',
		data: params.value,
		headers: {
			'Content-Type': 'application/json' // JSON으로 보내기
		}
	})
}

export function setUniAdapterStart(params) {
	return axios({
		method: 'post',
		url: prefixUni + '/set/start.do',
		data: params.value,
		headers: {
			'Content-Type': 'application/json' // JSON으로 보내기
		}
	})
}


// manual authentication
export function manualAuth() {
	return axios({
		method: 'post',
		url: prefix + '/auth/manual.do'
	})
}
export function getUniAdapterList() {
	return axios({
		method: 'get',
		url: prefixUni + '/get/adapter/list.do'
	})
}

export function exportUniAdapterInfo(adapterName) {
	return axios({
		method: 'get',
		url: prefixUni + '/export/adapter/json.do',
		params: {adapterName},
		responseType: 'blob',
	})
}

export function importUniAdapterInfo(formData) { 
	return axios({
		method: 'post',
		url: prefixUni + '/import/adapter/json.do',
		data: formData,
	})
}

export function setUniAdapterConnectParameters(payload) {
	return axios({
		method: 'post',
		url: prefixUni + '/set/connectParameters.do',
		data: payload,
	})
}

export function getUniAdapterConnectParameters(adapterName) {
	return axios({
		method: 'get',
		url: prefixUni + '/get/connectParameters.do',
		params: {adapterName},
	})
}
